import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Play, Youtube } from "lucide-react";
import api from "@/lib/api";
import { useProvince } from "@/contexts/ProvinceContext";

export default function VideosList() {
  const { selected } = useProvince();
  const [items, setItems] = useState([]);
  // "Kanalımıza Abone Ol" artık Ayarlar → Sosyal Medya → YouTube alanından yönetiliyor.
  // Alanı boşsa buton gizlenir; dolduğunda otomatik olarak yeni URL'ye yönlendirir.
  const [youtubeUrl, setYoutubeUrl] = useState("");
  useEffect(() => {
    api.get(`/videos?limit=24${selected ? `&province_id=${selected.id}` : ""}`).then((r) => setItems(r.data.items || []));
  }, [selected?.id]);
  useEffect(() => {
    let cancelled = false;
    api.get("/social-media").then((r) => {
      if (cancelled) return;
      setYoutubeUrl((r.data || {}).youtube || "");
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h1 className="text-2xl md:text-3xl font-black">Video İçerikler</h1>
          <p className="text-gray-500 text-sm">YouTube kanalımızın en yeni içerikleri</p>
        </div>
        {youtubeUrl && (
          <a
            href={youtubeUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 bg-[#FF0000] text-white rounded-md text-sm font-semibold hover:brightness-110"
            data-testid="videos-subscribe-btn"
          >
            <Youtube className="w-4 h-4" /> Kanalımıza Abone Ol
          </a>
        )}
      </div>
      <div className="grid md:grid-cols-3 gap-5">
        {items.map((v) => (
          <Link key={v.id} to={`/video/${v.id}`} className="news-card group">
            <div className="relative aspect-video overflow-hidden rounded-lg bg-black">
              <img src={v.thumbnail} alt={v.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/50 transition flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-[#e11d2a] flex items-center justify-center"><Play className="w-7 h-7 text-white" fill="white" /></div>
              </div>
            </div>
            <div className="p-3">
              <h3 className="font-bold line-clamp-2">{v.title}</h3>
              <p className="text-sm text-gray-500 line-clamp-2 mt-1">{v.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function VideoDetail() {
  const { id } = useParams();
  const [v, setV] = useState(null);
  useEffect(() => { api.get(`/videos/${id}`).then((r) => setV(r.data)); }, [id]);
  if (!v) return <div className="max-w-3xl mx-auto py-10 px-4">Yükleniyor...</div>;
  const embed = v.youtube_id ? `https://www.youtube.com/embed/${v.youtube_id}?rel=0` : v.youtube_url;
  return (
    <div className="max-w-4xl mx-auto px-4 py-6">
      <div className="aspect-video bg-black rounded-lg overflow-hidden">
        <iframe src={embed} title={v.title} className="w-full h-full" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
      </div>
      <h1 className="text-2xl font-black mt-4">{v.title}</h1>
      <p className="text-gray-600 mt-2">{v.description}</p>
    </div>
  );
}
